import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { PasswordChangeFormValues } from '@/account/schemas'

/**
 * `POST /admin/auth/password` (DEC-ADMIN-010).
 *
 * Saját admin password-change. Sikerre a backend a current session
 * tokent **megtartja** (NEM revokál — `currentAccessToken()->delete()`
 * nélkül). 401-et ad rossz `current_password`-re; 422-t a
 * `new_password` szabály-sérülésekre (min 12, letters, numbers).
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: async (body: PasswordChangeFormValues): Promise<void> => {
      const { error } = await apiClient.POST('/admin/auth/password', { body })
      if (error) throw error
    },
  })
}
